module.exports = __webpack_public_path__ + "img/Jacek Sieka.f831192e.jpg";